import Loader from '@/common/components/Loader/Loader';

export default Loader;
